import React from 'react';
import { Facebook, Instagram, Linkedin, Twitter, Youtube, Boxes } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function OlistFooter() {
  const footerColumns = [
    {
      title: 'Produtos',
      links: ['ERP Completo', 'Automação de Vendas', 'Integração Marketplace', 'Loja Virtual', 'Conciliação de Cartões']
    },
    {
      title: 'Soluções',
      links: ['Para Pequenas Empresas', 'Para Médio Varejo', 'Atacadistas', 'Franquias']
    },
    {
      title: 'Recursos',
      links: ['Blog', 'Materiais Ricos', 'Central de Ajuda', 'API Documentation', 'Status do Sistema']
    },
    {
      title: 'A Empresa',
      links: ['Sobre Nós', 'Carreiras', 'Imprensa', 'Contato', 'Parceiros']
    }
  ];

  return (
    <footer className="bg-white pt-24 pb-12 overflow-hidden border-t border-slate-100">
      <div className="container mx-auto px-6 max-w-7xl">
        
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          
          {/* Brand Info */}
          <div className="lg:col-span-1 flex flex-col gap-6">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center">
                <img src="/logo.png" alt="Lukos Logo" className="w-full h-full object-contain brightness-0 invert" />
              </div>
              <span className="text-2xl font-bold tracking-tight text-slate-900">
                lukos.
              </span>
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed">
              As melhores tecnologias, ferramentas e integrações na sua operação de vendas online e física. Acelere o seu negócio!
            </p>
          </div>
          
          {/* Links Columns */}
          {footerColumns.map((col, idx) => (
            <div key={idx} className="flex flex-col gap-6">
              <h4 className="text-slate-900 font-bold text-sm tracking-widest uppercase">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-4">
                {col.links.map((link, lIdx) => (
                  <li key={lIdx}>
                    <a href="#" className="text-slate-500 hover:text-[#7f00ff] text-sm font-medium transition-colors">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-slate-100 gap-6">
          <div className="flex items-center gap-6">
            <p className="text-slate-400 text-sm font-medium">
              &copy; {new Date().getFullYear()} Lukos Sistemas. Todos os direitos reservados.
            </p>
            <div className="hidden md:flex items-center gap-4 text-sm font-medium text-slate-500">
              <a href="#" className="hover:text-[#7f00ff] transition-colors">Termos</a>
              <a href="#" className="hover:text-[#7f00ff] transition-colors">Privacidade</a>
            </div>
          </div>
          
          {/* Socials */}
          <div className="flex items-center gap-4">
            <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-purple-50 hover:text-[#7f00ff] transition-all">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-purple-50 hover:text-[#7f00ff] transition-all">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-purple-50 hover:text-[#7f00ff] transition-all">
              <Youtube className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-purple-50 hover:text-[#7f00ff] transition-all">
              <Twitter className="w-5 h-5" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-purple-50 hover:text-[#7f00ff] transition-all">
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
        
      </div>
    </footer>
  );
}
